import WhatsNextCard from '../WhatsNextCard'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import NextProjectCard from 'components/shared/NextProjectCard/NextProjectCard'

const WhatsNextProjectInPath = ({
  currentPathwayName,
  currentPathwaySlug,
  nextProject,
}) => {
  const { t, i18n } = useTranslation()

  const pathwayLink = `/${i18n.language}/pathways/${currentPathwaySlug}`

  return (
    <WhatsNextCard
      description={t('project.project_complete.next-project-in-path', {
        title: currentPathwayName,
        link: pathwayLink,
      })}
    >
      <NextProjectCard project={nextProject} />
    </WhatsNextCard>
  )
}

WhatsNextProjectInPath.propTypes = {
  currentPathwaySlug: PropTypes.string.isRequired,
  currentPathwayName: PropTypes.string.isRequired,
  nextProject: PropTypes.object.isRequired,
}

export default WhatsNextProjectInPath
